var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticStyle: { display: "flex", "max-width": "calc(100vw - 75px)" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chatBarCurrentPage > 1,
                  expression: "chatBarCurrentPage > 1",
                },
              ],
              staticClass: "custom-chatbar-button",
              class:
                !_vm.isUnreadPage(_vm.chatBarCurrentPage - 1) && "none-unread",
              on: {
                click: function ($event) {
                  return _vm.setChatBarCurrentPageChange(
                    _vm.chatBarCurrentPage - 1
                  )
                },
              },
            },
            [_c("md-icon", [_vm._v("keyboard_arrow_left")])],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.chatBarPaginationList(), function (b, j) {
            return j === _vm.chatBarCurrentPage - 1
              ? _c(
                  "div",
                  {
                    staticStyle: { "margin-right": "auto" },
                    attrs: { id: "custom-chatbar" },
                  },
                  _vm._l(b, function (c, i) {
                    return _c("div", { key: i, staticClass: "item" }, [
                      !!c
                        ? _c(
                            "div",
                            {
                              class:
                                "short-key " + _vm.getChatBarColorClassNames(c),
                              style: {
                                transform: _vm.animation[c._id]
                                  ? "scale(1.5)"
                                  : "scale(1)",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggle(c)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(i + 1) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "custom-chatbar-box",
                          attrs: { "data-v-step": "22" },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.toggle(c)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.capitalize(
                                        c.fullname || c.whatsappNumber
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "time" },
                                [
                                  _c("passed-time-counter-ago", {
                                    attrs: { id: c._id, date: c.createdDate },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              c.meta.unread
                                ? _c("b-badge", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(c.meta.unread) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.activeConversation
                            ? _c(
                                "div",
                                { staticClass: "toolbox" },
                                [
                                  _vm.activeConversation &&
                                  _vm.activeConversation._id === c._id
                                    ? _c(
                                        "a-tooltip",
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t("message.hideChat")
                                                ) +
                                                "\n                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.hide.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "window-minimize",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isRoot ||
                                  _vm.user.role.permissions
                                    .map(function (x) {
                                      return x.name
                                    })
                                    .includes("visitor.block")
                                    ? _c(
                                        "a-tooltip",
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t("message.block_")
                                                ) +
                                                "\n                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.ban(
                                                    c._id,
                                                    c.fullname
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticStyle: {
                                                  color: "orange",
                                                },
                                                attrs: { icon: "ban" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.privateMessage_")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.pm(c._id)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticStyle: {
                                              color: "dodgerblue",
                                            },
                                            attrs: { icon: "user-secret" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.activeConversation &&
                                  _vm.activeConversation._id === c._id &&
                                  !_vm.observing.includes(c._id)
                                    ? _c(
                                        "a-tooltip",
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t("message.assignRep")
                                                ) +
                                                "\n                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.assign-agent",
                                                  modifiers: {
                                                    "assign-agent": true,
                                                  },
                                                },
                                              ],
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "headset" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              c.users.length > 1 ||
                                                _vm.observing.includes(c._id)
                                                ? _vm.$t("message.leaveChat")
                                                : _vm.$t("message.endChat")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.leave(c._id, true)
                                            },
                                          },
                                        },
                                        [
                                          c.users.length > 1 ||
                                          _vm.observing.includes(c._id)
                                            ? _c("font-awesome-icon", {
                                                staticStyle: { color: "red" },
                                                attrs: { icon: "sign-out-alt" },
                                              })
                                            : c.users.length === 1 ||
                                              _vm.observing.includes(c._id)
                                            ? _c("font-awesome-icon", {
                                                staticStyle: { color: "red" },
                                                attrs: { icon: "times" },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.chatBarPaginationList().length > _vm.chatBarCurrentPage,
                  expression:
                    "chatBarPaginationList().length > chatBarCurrentPage",
                },
              ],
              staticClass: "custom-chatbar-button",
              class:
                !_vm.isUnreadPage(_vm.chatBarCurrentPage + 1) && "none-unread",
              on: {
                click: function ($event) {
                  return _vm.setChatBarCurrentPageChange(
                    _vm.chatBarCurrentPage + 1
                  )
                },
              },
            },
            [_c("md-icon", [_vm._v("keyboard_arrow_right")])],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }